module.exports = __webpack_public_path__ + "img/Frame-88.d7782671.svg";